module.exports = __webpack_public_path__ + "static/media/julie.2ada29b8.png";